<div class="ngx-timepicker-container">
  <mat-label>Seleccione horario</mat-label>
  <ngx-timepicker-field [disabled]="isDisabled" [controlOnly]="true" [(ngModel)]="tiempoActual"
    (timeChanged)="getTimeValueEmit($event)" [format]="24" [defaultTime]="tiempoActual">
  </ngx-timepicker-field>
</div>
